/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageArtifactsInner } from './MessageArtifactsInner';
import {
    MessageArtifactsInnerFromJSON,
    MessageArtifactsInnerFromJSONTyped,
    MessageArtifactsInnerToJSON,
    MessageArtifactsInnerToJSONTyped,
} from './MessageArtifactsInner';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {object}
     * @memberof Message
     */
    data: object;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    createBy: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    uniqueKey: string;
    /**
     * List of artifacts associated with the message
     * @type {Array<MessageArtifactsInner>}
     * @memberof Message
     */
    artifacts?: Array<MessageArtifactsInner>;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    status: MessageStatusEnum;
}


/**
 * @export
 */
export const MessageStatusEnum = {
    Completed: 'completed',
    Pending: 'pending'
} as const;
export type MessageStatusEnum = typeof MessageStatusEnum[keyof typeof MessageStatusEnum];


/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('createBy' in value) || value['createBy'] === undefined) return false;
    if (!('uniqueKey' in value) || value['uniqueKey'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'type': json['type'],
        'createdAt': json['createdAt'],
        'createBy': json['createBy'],
        'uniqueKey': json['uniqueKey'],
        'artifacts': json['artifacts'] == null ? undefined : ((json['artifacts'] as Array<any>).map(MessageArtifactsInnerFromJSON)),
        'status': json['status'],
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'type': value['type'],
        'createdAt': value['createdAt'],
        'createBy': value['createBy'],
        'uniqueKey': value['uniqueKey'],
        'artifacts': value['artifacts'] == null ? undefined : ((value['artifacts'] as Array<any>).map(MessageArtifactsInnerToJSON)),
        'status': value['status'],
    };
}

